import { render, staticRenderFns } from "./subscription_prefs_form.vue?vue&type=template&id=7fd81ed9"
import script from "./subscription_prefs_form.vue?vue&type=script&lang=js"
export * from "./subscription_prefs_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fd81ed9')) {
      api.createRecord('7fd81ed9', component.options)
    } else {
      api.reload('7fd81ed9', component.options)
    }
    module.hot.accept("./subscription_prefs_form.vue?vue&type=template&id=7fd81ed9", function () {
      api.rerender('7fd81ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/subscription_prefs_form.vue"
export default component.exports